import { DisplayFormat, FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { ILabelProps } from "./ILabelProps";
import { formatValue } from "../../../helpers";

export const LabelProperties = [
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.Format, name: 'Format', type: PropertyType.DisplayFormat },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useLabelProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<ILabelProps>()
    const draftText = usePropertyDraftText({bindings, property: Property.Label})

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const labelValue = bindings.getValue<string>(Property.Label);
        const format = bindings.getValue<DisplayFormat>(Property.Format);
        const label = formatValue(labelValue, format)
        const title = bindings.getValue<string>(Property.Tooltip);
        const icon = bindings.getValue<string>(Property.MaterialIcon);

        setProperties({ label, title, icon })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
